import React, { useEffect, useState } from 'react';
import { fetchFasterUsersByMonth } from '../services/api';
import { ResponsiveLine } from '@nivo/line';
import { parseISO, format } from 'date-fns';
import Header from '../components/Header';


const transformYearlyData = (data) => {
  const yearly = {};
  
  data.forEach(({ left, yw_users, ed_users, overall }) => {
    if (!left) {
      return;
    }
    
    // Parse year directly from string to avoid timezone issues
    const year = parseInt(left.split('-')[0]);
    
    
    // Sum new users created in each year (not cumulative)
    if (!yearly[year]) {
      yearly[year] = { yw_users: 0, ed_users: 0, overall: 0 };
    }
    yearly[year].yw_users += yw_users;
    yearly[year].ed_users += ed_users;
    yearly[year].overall += overall;
  });
  

  return [
    {
      id: 'Young Writer Users',
      data: Object.entries(yearly).map(([year, val]) => ({ x: year, y: val.yw_users }))
    },
    {
      id: 'Educator Users',
      data: Object.entries(yearly).map(([year, val]) => ({ x: year, y: val.ed_users }))
    },
    {
      id: 'Overall Users',
      data: Object.entries(yearly).map(([year, val]) => ({ x: year, y: val.overall }))
    }
  ];
};

const transformMonthlyData = (data) => {
  const monthly = data.filter(({ left }) => {
    if (!left) {
      console.warn('Missing left value:', left);
      return false;
    }
    const date = new Date(left);
    return !isNaN(date) && date >= new Date('2020-01-01');
  });

  return [
    {
      id: 'Young Writer Users',
      data: monthly.map(({ left, yw_users }) => ({
        x: format(parseISO(left + '-01'), 'MMM yyyy'), 
        y: yw_users
      }))
    },
    {
      id: 'Educator Users',
      data: monthly.map(({ left, ed_users }) => ({
        x: format(parseISO(left + '-01'), 'MMM yyyy'),
        y: ed_users
      }))
    },
    {
      id: 'Overall Users',
      data: monthly.map(({ left, overall }) => ({
        x: format(parseISO(left + '-01'), 'MMM yyyy'),
        y: overall
      }))
    }
  ];
};

export default function CreatedUserTrends() {
  const [yearlyData, setYearlyData] = useState([]);
  const [monthlyData, setMonthlyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        const data = await fetchFasterUsersByMonth();
        console.log('Data:', data);
        setYearlyData(transformYearlyData(data));
        setMonthlyData(transformMonthlyData(data));
        console.log('Yearly:', transformYearlyData(data));
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-lg text-gray-600">Loading New User Trends...</div>
      </div>
    );
  }

    return (
      <div>
        <Header pageTitle="WtW New User Trends Over Time: By Year and By Month" />
        <div className="grid grid-cols-1 gap-6 p-4">
        <div style={{ height: '400px' }} className="bg-white rounded shadow p-4">
            <ResponsiveLine
            data={yearlyData}
            margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', min: 0, stacked: false }}
            axisBottom={{ legend: 'Year', legendOffset: 36, legendPosition: 'middle' }}
            axisLeft={{ legend: 'Users', legendOffset: -40, legendPosition: 'middle' }}
            pointSize={6}
            pointBorderWidth={2}
            useMesh={true}
            colors={{ scheme: 'category10' }}
            legends={[{
                anchor: 'top-right',
                direction: 'column',
                justify: false,
                translateX: 100,
                translateY: 0,
                itemsSpacing: 4,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [{ on: 'hover', style: { itemBackground: 'rgba(0, 0, 0, .03)', itemOpacity: 1 } }]
            }]}
            />
        </div>

        <div style={{ height: '400px' }} className="bg-white rounded shadow p-4">
            <ResponsiveLine
            data={monthlyData}
            margin={{ top: 50, right: 110, bottom: 80, left: 60 }}
            xScale={{ type: 'point' }}
            yScale={{ type: 'linear', min: 0, stacked: false }}
            axisBottom={{ legend: 'Month', legendOffset: 60, legendPosition: 'middle', tickRotation: -45 }}
            axisLeft={{ legend: 'Users', legendOffset: -40, legendPosition: 'middle' }}
            pointSize={6}
            pointBorderWidth={2}
            useMesh={true}
            colors={{ scheme: 'category10' }}
            legends={[{
                anchor: 'top-right',
                direction: 'column',
                justify: false,
                translateX: 100,
                translateY: 0,
                itemsSpacing: 4,
                itemDirection: 'left-to-right',
                itemWidth: 80,
                itemHeight: 20,
                symbolSize: 12,
                symbolShape: 'circle',
                effects: [{ on: 'hover', style: { itemBackground: 'rgba(0, 0, 0, .03)', itemOpacity: 1 } }]
            }]}
            />
        </div>
        </div>
        </div>
    );
}
